/* eslint-disable max-len */
import { useLoadScript } from "@react-google-maps/api";
import { LicenseInfo } from "@mui/x-license-pro";

import Providers from "./providers";
import Router from "./router";

const libraries = ["places"];

function App() {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || "",
    // @ts-ignore
    libraries
  });

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div className="opacity-0">Loading Maps</div>;
  }

  LicenseInfo.setLicenseKey(`${process.env.REACT_APP_MUI_LICENSE_KEY}`);

  return (
    <Providers>
      <Router />
    </Providers>
  );
}

export default App;
